define('responsive-gameday/controllers/LinescoreViewController',['require','exports','module','GameDayCore','jquery','Wax/Wax','Responsive/controllers/ViewController','../views/render/LinescoreViewRender','message-service/message-service','../views/Monitor/Events/ViewModelUpdateEvents','../views/Monitor/Events/SceneStateEvents','responsive-gameday-tracking/responsive-gameday-tracking','GameDayCore/GDModel/enums/datasources/Datasources','GameDayCore/GDUtil/window/Logg','extant/extant','Responsive/vendor','iscroll/build/iscroll'],function(require,exports,module) {

    // Add private variables here
    var GDC = require("GameDayCore"),
        $ = require('jquery'),
        Wax = require("Wax/Wax"),
        ViewController = require("Responsive/controllers/ViewController"),
        LinescoreViewRender = require( '../views/render/LinescoreViewRender' ),
        MessageService = require("message-service/message-service"),
        VMEvents = require("../views/Monitor/Events/ViewModelUpdateEvents"),
        SceneEvnets = require("../views/Monitor/Events/SceneStateEvents"),
        Tracking = require("responsive-gameday-tracking/responsive-gameday-tracking"),
        Datasources = require("GameDayCore/GDModel/enums/datasources/Datasources"),
        Logg = require("GameDayCore/GDUtil/window/Logg"),
        exists = require("extant/extant"),
        vendor = require("Responsive/vendor"),
        iScroll = require( 'iscroll/build/iscroll' ),
        usableOptions = {
            bindToWrapper       : false,
            mouseWheel          : false,
            interactiveScrollbars : true,
            scrollX: true, 
            scrollY: false,
            scrollbars: true,
            preventDefault : true,
            fadeScrollbars : true,
            snap : true,
            eventPassthrough : 'vertical'
        };
        
        iScroll=iScroll || window.IScroll||window.iScroll;

    var Superclass,
        renderers = null;

    // Add private methods here
    // Constructor
    function LinescoreViewController(mini) {
        this.referenceName = "linescore";
        this.chyronAds = [];
        this.isMini = mini===true;
        this.viewRender = new LinescoreViewRender();

        var self = this,
            jDiv,
            jContainer,
            jStage;

        // Call super constructor
        Superclass.constructor.call(this);

        this.playJingle = function (payload, evt) {

            var staticresources = GDC.getGameData(Datasources.STATIC_RESOURCES).staticresources;
            var jingleName = staticresources.getJingleMapping(payload);
            Logg.log("play " + jingleName + " jingle");

            Tracking.track_jingle(jingleName);

            if (exists(document.getElementById("jingles"))) { return; }
            MessageService.addListener(GDC.requestGameData(Datasources.JINGLES, { jingle: jingleName }), jingleListener);
        };

        function jingleListener(payload, evt) {
            jDiv = document.createElement("div");

            jDiv.id = "jingles";
            jDiv.className = "jingleContainer";
            jDiv.innerHTML = self.viewRender.renderPartial('jingleView',{});

            // Start invisible
            jDiv.style.opacity = 0;
            self.getView().appendChild(jDiv);

            // Apply initial style state
            window.getComputedStyle(jDiv).opacity;

            // Fade it in (because of css transition on .jingleContainer)
            jDiv.style.opacity = 1;

            jContainer = document.getElementById('jingleContainer');
            jStage = new SwiffyWrapper.swiffy.Stage(jContainer, payload.jingles);

            SwiffyWrapper.bind("SwiffyEvent.RELAY", jingleCompleteHandler);
			MessageService.addListener("swiffy_animation_complete", removeSwiffy);

            jStage.start();
        }

        function jingleCompleteHandler(payload, evt) {
            Logg.log("SWIFFY EVENT: " + evt.eventName);
            if (evt.eventName === "complete") {
                SwiffyWrapper.unbind("SwiffyEvent.RELAY", jingleCompleteHandler);

				removeSwiffy();
            }
        }

		function removeSwiffy() {
			jDiv = document.getElementById("jingles");
            if(!jDiv) {
                // Already removed
                return;
            }
			jDiv.style.opacity = 0;

			window.getComputedStyle(jDiv).opacity;

			setTimeout(function() {
                if(jDiv) {
    				jDiv.parentNode.removeChild(jDiv);
    				jDiv = jContainer = jStage = null;
                }
			}, 1000);

			MessageService.removeListener("swiffy_animation_complete", removeSwiffy);
		}

        this.updateAds = function (payload, evt) {
            var newAds = (exists(payload)) ? payload : this.chyronAds;
            self.chyronAds = newAds;

            if (!exists(newAds) || newAds.length < 2) { return; }
            var adverts = document.getElementsByClassName("chyron-ad");

            if (!exists(adverts)) {
                Logg.log("oops i could not find the chyron ads, dude.")
            } else {
                for (var i = 0, l = adverts.length; i < l; i++) {
                    adverts[i].style.backgroundImage = newAds.img;
                    adverts[i].href = newAds.clickHref;
                    adverts[i].target = "_blank";
                }
            }
        };

        MessageService.publish("registerViewComponent", this);
    }
    
    LinescoreViewController.embeddedHelper = function (view, data) {
        // return;
        var linescoreData = data && data.innings || [],
            that = view = view || this,
            $view=$(view.getView());
            data.linescore_skin = linescoreData.length > 9 ? "next previous" : '';
    };
    
    LinescoreViewController.setEmbeddableScrollBar  = function (view,data) {
            var $view = $(view.getView());
            var scrollDiv = $view.find(".right-scroll");
             if (scrollDiv.length === 0 || (data && data.inning_line_score && data.inning_line_score.length <= 9)) {
                return false;
             }
             var sbScroll = new iScroll(scrollDiv.get(0), usableOptions),
                startP = view.sbScroll || {
                    x : sbScroll.maxScrollX,
                    y : 0
                };
             sbScroll.scrollTo(startP.x, startP.y, 0);
             sbScroll.on('scrollStart',function(){console.warn(arguments)});
             view.sbScroll = sbScroll;
             LinescoreViewController.embeddeScrollerdHelper(view);             
    };
    
    LinescoreViewController.embeddeScrollerdHelper = function (view,data) {
        var $view = $(view.getView());
            
        if(view.sbScroll && $view.length && !vendor.hasTouch){

            $view.off('click','.inning_button')
                .on('click','.inning_button.prev_button',function(e){
                    view.sbScroll.prev();
                    e.stopImmediatePropagation();
                    return false;                
                }).on('click','.inning_button.next_button',function(e){
                    view.sbScroll.next();
                    e.stopImmediatePropagation();
                    return false;
                });
            }
    };

    // Prototype Inheritence
    ViewController.spawn(LinescoreViewController).define({
        gameData: null,
        draw: function () {
            Superclass.draw.call(this);
            this.setClassName('LinescoreViewController');
            if(this.isMini){
                this.setClassName('mini-linescore');
            }
        },

        drawLinescore : function(payload){
            this.gameData = payload || this.gameData;
            this.view.innerHTML=this.viewRender.render(this.gameData);
            this.drawScoreboardAds();
            LinescoreViewController.setEmbeddableScrollBar(this,payload.linescore);
            LinescoreViewController.embeddeScrollerdHelper(this,payload.linescore);

        },
        drawScoreboardAds: function() {
            if (!exists(this.chyronAds)) { setTimeout(function() { MessageService.publish("gdPageAdsUpdated") }, 250); }
            else { this.updateAds(); }
        },



        viewWillAppear: function () {
            Superclass.viewWillAppear.call(this);
            MessageService.addListener.call(this, VMEvents.UPDATE_CHYRON, this.drawLinescore);
            MessageService.publish(VMEvents.REQUEST_CHYRON_DATA);
        },

        viewWillDisappear: function () {
            Superclass.viewWillDisappear.call(this);
            MessageService.removeListener.call(this, VMEvents.UPDATE_CHYRON, this.drawLinescore);
        }
    });

    Superclass = LinescoreViewController.superclass;
    return LinescoreViewController;
});
